import { IReduxAction } from '@bees-web/core/types'
import {
  SET_BRANDS_BANNERS,
  SET_BRANDS_BANNERS_HEIGHT,
  SET_BRANDS_STORE,
} from '../../constants/banners'

export const setBrandsBanners = (slidesBrands: object): IReduxAction => ({
  type: SET_BRANDS_BANNERS,
  payload: { slidesBrands },
})

export const setBrandsBannersHeight = (
  heightBrands: number | string
): IReduxAction => ({
  type: SET_BRANDS_BANNERS_HEIGHT,
  payload: { heightBrands },
})

export const setBrandsStore = (meta): IReduxAction => ({
  type: SET_BRANDS_STORE,
  payload: { meta },
})
